import { Capacitor } from '@capacitor/core';
import { backendApi } from '../../../utils/backendApi';
import { GroupRoles, ProfileClaim, RolesClaim } from '@bp/pim-auth-constants';
import { Browser } from '@capacitor/browser';

type PimAuthClaims = {
  getProfile: () => ProfileClaim;
  getRoles: () => RolesClaim;
};

export const startAndJoinMeeting = async (
  onlineLocationToken: string | undefined,
  pimAuthClaims: PimAuthClaims,
  contextUuid: string = '',
): Promise<boolean> => {
  let success = !!onlineLocationToken;

  if (onlineLocationToken) {
    const joinUrl = await backendApi.joinConference(onlineLocationToken, {
      displayName: pimAuthClaims.getProfile().displayName ?? '',
      email: pimAuthClaims.getProfile().email ?? '',
      profileUuid: pimAuthClaims.getProfile().uuid ?? '',
      moderator:
        pimAuthClaims
          .getRoles()
          .find(
            (r) =>
              r.target.uuid === contextUuid &&
              (r.name.includes(GroupRoles.Admin) || r.name.includes(GroupRoles.Editor)),
          ) !== undefined,
    });

    const url = await joinUrl.text();
    if (url.includes('https://')) {
      if (Capacitor.isNativePlatform()) {
        Browser.open({ url });
      } else {
        window.open(url, '_blank');
      }
    } else {
      success = false;
    }
  }

  return success;
};
